import sendReportRequest from './sendReportRequest';

const fetchReportTipsByStaff = async ({ dateRange, from, to, reportingType }) => {
  const reponseData = await sendReportRequest({
    url: '/reports/tipsByStaffMember',
    dateRange,
    from,
    to,
    reportingType,
  });

  return reponseData;
};

export default fetchReportTipsByStaff;
